import React, {Component} from 'react'
import Waypoint from 'react-waypoint'
import { connect } from 'react-redux'
import Heading from 'grommet/components/Heading'
import Paragraph from 'grommet/components/Paragraph'
import Image from 'grommet/components/Image'
import SeparatorBar from '../SeparatorBar'
import {setAboutVisibility} from '../../actions/sections/AboutActions'
import { setParticleVisibility, setSectionProperty } from '../../actions/sections/SectionsActions'
import officeImage from './resources/images/office.jpg'
import './About.css'

@connect((state) => ({
  isVisible: state.sectionsReducer.about.isVisible,
  isMobile: state.configReducer.mobile,
  aboutSeparatorBarExpanded: state.sectionsReducer.about.separatorBarExpanded
}), {setAboutVisibility, setParticleVisibility, setSectionProperty})
class About extends Component {
  handleWaypointEnter = () => {
    const {setAboutVisibility, setParticleVisibility, setSectionProperty } = this.props
    setParticleVisibility('home', 'sectionOneParticlesVisible', false)
    setParticleVisibility('home', 'sectionTwoParticlesVisible', true)
    setAboutVisibility(true)
    setSectionProperty('about', 'separatorBarExpanded', true)
  }

  handleWaypointLeave = () => {
    const {setAboutVisibility, setSectionProperty} = this.props
    setAboutVisibility(false)
    setSectionProperty('about', 'separatorBarExpanded', false)
  }

  render() {
    const {isVisible, isMobile, aboutSeparatorBarExpanded } = this.props
    const className = `About ${isVisible ? 'is-visible' : ''}`
    const separatorBarClassName = `About-separatorBar${aboutSeparatorBarExpanded ? ' is-expanded' : ''} `
    return (
      <div className={className}>
        <Waypoint scrollableAncestor={window} onEnter={this.handleWaypointEnter} onLeave={this.handleWaypointLeave}>
          <div className="About-container">
            { !isMobile && <SeparatorBar className={separatorBarClassName}/> }
            <div className="About-child About-textContainer">
              <Heading tag="h2" uppercase={true} strong={true}>About Us</Heading>
              <Heading tag="h4" strong={true} size='small'>
                We are a software consultancy born out of pure passion for technology.
              </Heading>
              <Paragraph className="About-paragraph" align="center">
                Based in Waterford Ireland, we are a luxury web design agency with a passionate team and international
                portfolio of successful web applications and mobile apps.
                {/*We believe in developing aesthetically beautiful websites with an engineering under-the-hood that will ensure your website is sustainable and future-proof.*/}
              </Paragraph>
              <Paragraph className="About-paragraph" align='center'>
                We are crafters of effective solutions for mobile and web.
                As a young company we are passionate about helping our clients succeed in an increasingly digital world.
                Our dedicated service, knowledge and quality is what sets us apart.
              </Paragraph>
            </div>
            <div className="About-child About-imageContainer">
              <Image className="About-image" src={officeImage} alt="About Copper Coast Technologies"/>
            </div>
          </div>
        </Waypoint>
      </div>
    )
  }
}

export default About


// WEBPACK FOOTER //
// ./src/components/About/index.js